import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafeResourcePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  public transform(unsafeResource): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(unsafeResource);
  }
}
